// @flow

import * as React from 'react';
import Waypoint from 'react-waypoint';

type Props = {
  children: React.Node,
  className?: string,
  id: string,
}

/*
* Don't add refSave and enterWaypoint to props type.
* They are not supposed to be implemented by the componenet user
*/
class MenuPage extends React.PureComponent<Props> {
  static defaultProps = {
    className: '',
  };

  render() {
    return (
      <div ref={ref => this.props.refSave(ref)}>
        <Waypoint
          topOffset="50%"
          bottomOffset="49%"
          onEnter={() => this.props.enterWaypoint(this.props.id)}
        >
          <div className={this.props.className}>
            {this.props.children}
          </div>
        </Waypoint>
      </div>

    );
  }
}

export default MenuPage;
